export default "__VITE_ASSET__46ee15d9__"